import HotelFacilities from './HotelFacilities.component';
export default HotelFacilities;